export default __webpack_public_path__ + "static/29107-7d9975a184bf99333f4e684e1fe78c7d.jpg";